import { createTheme } from '@mui/material/styles';

// assets
import colors from '../assets/scss/_themes-vars.module.scss';

// project imports
import { componentStyleOverrides } from './compStyleOverride';
import { themePalette } from './palette';
import { themeTypography } from './typography';

import { useLocation } from 'react-router-dom';
import { useTheme } from '@mui/styles';


/**
 * Theme
 *
 * @summary Generates a Material-UI theme object based on the provided customization options and current route.
 *
 * @description
 * Constructs a theme configuration using color variables, typography, palette, breakpoints, and component style overrides. Uses the current route path to adjust typography settings. Returns a theme object for use with Material-UI's ThemeProvider.
 *
 * @param {Object} customization - The customization options for the theme (e.g., colors, border radius).
 *
 * @returns {Object} The generated Material-UI theme object.
 *
 * @example
 * const theme = Theme(customization);
 */
export function Theme(customization) {
    const color = colors;
    const theme = useTheme();

    const location = useLocation();
    const path = location.pathname;

    let themeOption = {
        colors: color,
        heading: color.grey900,
        paper: color.paper,
        backgroundDefault: color.primaryLight, // color.paper,
        background: color.primaryLight,
        darkTextPrimary: color.grey700,
        darkTextSecondary: color.grey500,
        textDark: color.grey900,  // text color 
        menuSelected: color.secondaryDark,
        menuSelectedBack: color.secondaryLight,
        divider: color.grey200,
        customization: customization
    };

    return createTheme({
        direction: 'ltr',
        palette: themePalette(themeOption),
        mixins: {
            toolbar: {
                minHeight: '4px',
                padding: '1px',
                '@media (min-width: 600px)': {
                    minHeight: '4px'
                }
            }
        },
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 960,
                lg: 1280,
                xl: 1920
            }
        },
        typography: themeTypography(themeOption, path),
        components: componentStyleOverrides(themeOption)
    });
}

export default Theme;
